import { render, staticRenderFns } from "./item-page.vue?vue&type=template&id=44cacd18&scoped=true&"
import script from "./item-page.vue?vue&type=script&lang=js&"
export * from "./item-page.vue?vue&type=script&lang=js&"
import style0 from "./item-page.vue?vue&type=style&index=0&id=44cacd18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cacd18",
  null
  
)

export default component.exports